module.exports = __webpack_public_path__ + "img/arrowD.0d8b6beb.svg";